interface MetricCardProps {
  label: string;
  value: number | null;
  unit?: '%' | 'count' | 'points';
  deltaPct?: number;
  loading?: boolean;
}

export function MetricCard({ label, value, unit = 'count', deltaPct, loading }: MetricCardProps) {
  const formattedValue =
    value === null
      ? '—'
      : unit === '%'
        ? `${value.toFixed(1)}%`
        : unit === 'points'
          ? value.toLocaleString('it-IT')
          : value.toLocaleString('it-IT');

  const deltaColor =
    deltaPct === undefined
      ? ''
      : deltaPct >= 0
        ? 'text-green-600'
        : 'text-red-500';

  const deltaArrow = deltaPct === undefined ? '' : deltaPct >= 0 ? '↑' : '↓';
  const deltaText =
    deltaPct === undefined
      ? null
      : `${deltaArrow} ${deltaPct >= 0 ? '+' : ''}${deltaPct.toFixed(1)}%`;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
      <p className="text-sm text-gray-500 truncate">{label}</p>
      {loading ? (
        <div className="mt-1 h-8 w-24 bg-gray-100 rounded animate-pulse" />
      ) : (
        <div className="mt-1 flex items-baseline gap-2">
          <span className="text-2xl font-semibold text-gray-900">{formattedValue}</span>
          {deltaText && (
            <span className={`text-sm font-medium ${deltaColor}`}>{deltaText} vs prev</span>
          )}
        </div>
      )}
    </div>
  );
}
